<template>
    <div class="my-export-file-page layout-sub-page">
        <!-- 1. 标题部分 -->
        <title-bar 
            v-bind:className="'my-send-select-title-bar'"
            v-bind:titleData="titleData"
            v-bind:backFunc="clickBack">
        </title-bar>

        <div class="my-send-select-content">
            <div class="my-export-file-title">*使用导出功能进行全量导出备份，可保存数据永久不丢失，可由自己离线进行打印及其它保管控制。</div>

            <div class="my-export-file-detail-info">
                <div class="detail-title">将导出当前账号下所有的八字记录以及相关标签信息、批盘信息、论盘信息。</div>
                <div class="my-export-file-detail-list">
                    <div class="my-export-file-detail-item">
                        <span class="circle"></span>当前八字共计数：{{recordTotalData.length}}
                    </div>
                    <div class="my-export-file-detail-item">
                        <span class="circle"></span>有标签的八字数：{{recordTotalData.filter(el => el.label != '').length}}
                    </div>
                    <div class="my-export-file-detail-item">
                        <span class="circle"></span>有批盘的八字数：{{recordTotalData.filter(el => el.pipan).length}}
                    </div>
                    <div class="my-export-file-detail-item">
                        <span class="circle"></span>有论盘的八字数：{{recordTotalData.filter(el => el.nunpan).length}}
                    </div>
                </div>
            </div>

            <div class="my-export-file-detail-email">
                <div class="email-title">请填写接受导出文件的电子邮箱地址：</div>
                <div class="email-input-box">
                    <input class="email-input" v-model="emailUrl" type="email" placeholder="xxx@qq.com" maxlength="50" required />
                </div>
            </div>

            <div class="my-export-file-detail-button">
                <div class="collate-form-btn-main">
                    <button class="button-green" @click="clickExport">马上导出数据</button>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import { MIX, UTILS } from '../../modules/utils';
export default {
    name: 'MyExportFile',
    components: { TitleBar },
    computed: {
        recordTotalData() {
            return this.$store.state.record.recordTotalData;
        },
        userData() {
            return this.$store.state.userData;
        }
    },
    data() {
        return {
            titleData: {
                'titleText': '导出全部数据至电脑文件', 
                'hideButton': true, 
                'showCancel': false
            },
            emailUrl: ''
        }
    },
    mounted() {
        setTimeout(() => {
            MIX.trackPageViewed('ExportBz2Email');
        }, 20);
    },
    methods: {
        clickBack() {
            this.$router.replace('/my');
        },
        clickExport() {
        
            let userVip = this.userData.vip;
            if(userVip <= 20) {
                this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'exportfile'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
                return;
            }
            if(this.emailUrl == '') {
                this.$toast("请先输入邮箱");
                return;
            }
            let checkEmail = UTILS.isEmailAvailable(this.emailUrl);
            if(!checkEmail) {
                this.$toast("请输入正确的邮箱地址");
                return;
            }
            this.$store.dispatch('user/submitExportFile', {
                emailUrl: this.emailUrl,
                cb: () => {
                    this.$dialog.alert({
                        title: '',
                        confirmButtonText: '知道了',
                        message: '导出请求已提交，<br />请在5-10分钟后去邮箱查收。',
                    }).then(() => {
                        // on close
                        this.$router.replace('/my')
                    });
                }
            })
        }
    }
}
</script>
